import React from "react";

import { cn } from "@/styles/cn";

import { selectItemVariants, type SelectItemVariantsProps } from "./SelectItem.styles";

type SelectItemProp = React.LabelHTMLAttributes<HTMLLabelElement> & SelectItemVariantsProps;

export function SelectItem({ className, size, ...props }: SelectItemProp) {
  return (
    <li>
      <label className={cn(selectItemVariants({ size }), className)} {...props} />
    </li>
  );
}

type SelectItemTextProp = Readonly<React.HTMLAttributes<HTMLSpanElement>>;
export function SelectItemText({ className, ...props }: SelectItemTextProp) {
  return (
    <span
      className={cn(
        "block w-full overflow-hidden truncate whitespace-nowrap pl-[0.3rem]",
        className,
      )}
      {...props}
    />
  );
}

SelectItem.Text = SelectItemText;
